import { action, observable } from 'mobx';
import QuizItemSettings from './QuizItemSettings';


export class HeaderItemSettings extends QuizItemSettings {
    constructor(s?: Partial<HeaderItemSettings>) {
        super();
        if (s)
            this.update(s);
    }

    /** markdown */
    @observable text: string;
    @observable textHtml: string;
    @observable fontSize: number;
    @observable textColor?: string;

    @action update(q: Partial<HeaderItemSettings>, allowUndefined = false) {
        super.update(q, allowUndefined);
    }

    static build(settings?: Partial<HeaderItemSettings>) {
        return new HeaderItemSettings({
            ...QuizItemSettings.default,
            text: '',
            fontSize: 25,
            ...settings
        });
    }

    clone() {
        return new HeaderItemSettings({
            ...this
        });
    }

    static fromJson(json: any) {
        return HeaderItemSettings.build(json);
    }
}
